const DEMO_EVENT_TYPES = [
  { typeId: -3, titleRU: "Рабочее время", titleEN: "work_time" },
  { typeId: -2, titleRU: "Переписка", titleEN: "correspondence" },
  { typeId: 101, titleRU: "CRM-активности", titleEN: "crm_activity" },
  { typeId: 102, titleRU: "Задачи", titleEN: "tasks" },
  { typeId: 103, titleRU: "Сделки", titleEN: "deals" },
  { typeId: 105, titleRU: "Смена стадии", titleEN: "crm_stage" },
  { typeId: 106, titleRU: "Комментарии CRM", titleEN: "crm_comments" },
  { typeId: 113, titleRU: "Почта", titleEN: "email" },
  { typeId: 201, titleRU: "Звонки", titleEN: "calls" },
];

const DEMO_USERS_BY_DEPS = [
  {
    id: "sales",
    name: "Отдел продаж",
    users: [
      { id: 101, name: "Анна Морозова" },
      { id: 102, name: "Иван Петров" },
      { id: 103, name: "Мария Волкова" },
      { id: 104, name: "Дмитрий Кузнецов" },
    ],
  },
  {
    id: "sdr",
    name: "Группа первичных продаж",
    users: [
      { id: 201, name: "Елена Смирнова" },
      { id: 202, name: "Артем Соколов" },
      { id: 203, name: "Кирилл Орлов" },
    ],
  },
  {
    id: "success",
    name: "Клиентский отдел",
    users: [
      { id: 301, name: "Ольга Никитина" },
      { id: 302, name: "Павел Андреев" },
      { id: 303, name: "Наталья Федорова" },
    ],
  },
];

const DEMO_PROFILES = {
  101: { level: 8, calls: 3, messages: 7, riskEvery: 11, morningBias: 0 },
  102: { level: 5, calls: 2, messages: 3, riskEvery: 7, morningBias: 0 },
  103: { level: 9, calls: 3, messages: 8, riskEvery: 13, morningBias: 0 },
  104: { level: 2, calls: 1, messages: 1, riskEvery: 3, morningBias: 0 },
  201: { level: 6, calls: 5, messages: 4, riskEvery: 8, morningBias: 0 },
  202: { level: 4, calls: 2, messages: 3, riskEvery: 5, morningBias: 0 },
  203: { level: 5, calls: 4, messages: 4, riskEvery: 6, morningBias: 1 },
  301: { level: 6, calls: 2, messages: 8, riskEvery: 9, morningBias: 0 },
  302: { level: 3, calls: 1, messages: 2, riskEvery: 4, morningBias: 0 },
  303: { level: 7, calls: 3, messages: 6, riskEvery: 10, morningBias: 0 },
};

const CRM_TIMES = [
  "09:12",
  "09:48",
  "10:24",
  "11:05",
  "11:42",
  "12:22",
  "13:18",
  "14:06",
  "14:48",
  "15:28",
  "16:10",
  "16:52",
  "17:24",
];

const CALL_TIMES = ["09:35", "10:50", "12:42", "14:26", "16:18"];
const MESSAGE_TIMES = ["10:12", "11:28", "13:42", "15:02", "16:34", "17:08"];
const CRM_TYPES = [101, 102, 103, 105, 106, 113];

const DEMO_SETTINGS = {
  subdomain: "demo.panel",
  timezone: "Europe/Moscow",
  workingHours: "09:00-18:00",
  customWorkingTime: false,
  showTotalInTime: false,
  customEventsEnabled: false,
  maxMinutesBetweenEventsCountAsWork: 20,
  NOT_UNION_EVENT_TYPES_MAP: {
    "-2": true,
    201: true,
  },
};

const normalizeFilterSet = (values) => {
  if (!Array.isArray(values) || !values.length) {
    return null;
  }

  return new Set(values.map((value) => String(value)));
};

const getDayStart = (day) =>
  Math.floor(new Date(`${day}T00:00:00+03:00`).getTime() / 1000);

const getDateParts = (day) => {
  const date = new Date(`${day}T00:00:00+03:00`);

  return {
    weekday: date.getDay(),
    monthDay: date.getDate(),
  };
};

const addMinutes = (dayStart, time) => {
  const [hours, minutes] = time.split(":").map(Number);

  return dayStart + hours * 60 * 60 + minutes * 60;
};

const createEvent = (dayStart, typeId, time, duration = 60, extra = {}) => ({
  typeId,
  startAt: addMinutes(dayStart, time),
  duration,
  ...extra,
});

const createWorkTime = (dayStart) => ({
  typeId: -3,
  startAt: addMinutes(dayStart, "09:00"),
  duration: 9 * 60 * 60,
});

const addPatternShift = (time, shiftMinutes) => {
  const [hours, minutes] = time.split(":").map(Number);
  const total = Math.max(9 * 60, Math.min(17 * 60 + 35, hours * 60 + minutes + shiftMinutes));
  const shiftedHours = Math.floor(total / 60);
  const shiftedMinutes = total % 60;

  return `${String(shiftedHours).padStart(2, "0")}:${String(shiftedMinutes).padStart(2, "0")}`;
};

const getDailyLoad = (day, userId) => {
  const profile = DEMO_PROFILES[userId] || DEMO_PROFILES[101];
  const { weekday, monthDay } = getDateParts(day);

  if (weekday === 0 || weekday === 6) {
    return Math.max(1, Math.round(profile.level * 0.35));
  }

  let level = profile.level;
  const seed = (monthDay + Number(userId)) % 10;

  if (seed === 0) {
    level += 2;
  } else if (seed <= 2) {
    level -= 2;
  } else if (seed === 3) {
    level -= 1;
  }

  if (monthDay % profile.riskEvery === 0) {
    level = Math.max(1, Math.round(level * 0.35));
  }

  if (profile.morningBias && monthDay % 4 === 0) {
    level -= 2;
  }

  return Math.max(1, Math.min(11, level));
};

const pickTimes = (source, count, seed, morningBias = false) => {
  const times = morningBias
    ? source.slice(0, Math.max(count + 2, 5))
    : source;
  const result = [];

  for (let index = 0; index < count; index++) {
    result.push(times[(index * 2 + seed) % times.length]);
  }

  return Array.from(new Set(result)).slice(0, count);
};

const createUserEvents = (day, userId) => {
  const dayStart = getDayStart(day);
  const profile = DEMO_PROFILES[userId] || DEMO_PROFILES[101];
  const { monthDay, weekday } = getDateParts(day);
  const dailyLoad = getDailyLoad(day, userId);
  const seed = (monthDay + Number(userId)) % 6;
  const shift = ((monthDay + Number(userId)) % 5) * 3;
  const events = [createWorkTime(dayStart)];
  const crmCount = Math.max(1, dailyLoad);
  const callCount = weekday === 0 || weekday === 6
    ? Math.min(1, profile.calls)
    : Math.min(profile.calls + (dailyLoad >= 8 ? 1 : 0), CALL_TIMES.length);
  const messageCount = weekday === 0 || weekday === 6
    ? Math.min(2, profile.messages)
    : profile.messages + (dailyLoad >= 7 ? 2 : 0);
  const crmTimes = pickTimes(CRM_TIMES, crmCount, seed, Boolean(profile.morningBias));
  const callTimes = pickTimes(CALL_TIMES, callCount, seed);
  const messageTimes = pickTimes(MESSAGE_TIMES, Math.min(4, Math.ceil(messageCount / 2)), seed);

  crmTimes.forEach((time, index) => {
    const typeId = CRM_TYPES[(index + Number(userId) + monthDay) % CRM_TYPES.length];

    events.push(
      createEvent(dayStart, typeId, addPatternShift(time, shift), 60)
    );
  });

  callTimes.forEach((time, index) => {
    const duration = 180 + ((monthDay + index + Number(userId)) % 7) * 75;

    events.push(
      createEvent(dayStart, 201, addPatternShift(time, shift), duration)
    );
  });

  messageTimes.forEach((time, index) => {
    const count = Math.max(
      1,
      Math.round(messageCount / Math.max(messageTimes.length, 1)) +
        ((monthDay + index + Number(userId)) % 2)
    );

    events.push(
      createEvent(dayStart, -2, addPatternShift(time, shift), 60, {
        messageCount: count,
      })
    );
  });

  return events.sort((a, b) => a.startAt - b.startAt);
};

const filterEvents = (eventsByUser, query = {}) => {
  const userFilter = normalizeFilterSet(query.users);
  const typeFilter = normalizeFilterSet(query.eventTypes);
  const result = {};

  Object.keys(eventsByUser).forEach((userId) => {
    if (userFilter && !userFilter.has(String(userId))) {
      return;
    }

    result[userId] = eventsByUser[userId].filter((event) => {
      const typeId = String(event.typeId);

      return typeId === "-3" || !typeFilter || typeFilter.has(typeId);
    });
  });

  return result;
};

const getAllUserIds = () =>
  DEMO_USERS_BY_DEPS.flatMap((department) =>
    department.users.map((user) => user.id)
  );

const getDefaultDemoDay = () =>
  new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

export default {
  provider: "demo",

  getStorageScope() {
    return "demo";
  },

  async getLookup() {
    return {
      usersByDeps: DEMO_USERS_BY_DEPS,
      eventTypes: DEMO_EVENT_TYPES,
    };
  },

  async getDayEvents(day, query = {}) {
    const targetDay = day || getDefaultDemoDay();
    const events = Object.fromEntries(
      getAllUserIds().map((userId) => [userId, createUserEvents(targetDay, userId)])
    );

    return filterEvents(events, query);
  },

  async getSettings() {
    return DEMO_SETTINGS;
  },

  async getPortalStatus() {
    return {
      ok: true,
      provider: "demo",
      scope: "demo",
      demo: true,
    };
  },
};
